import {environment} from '../../../environments/environment';

export class COMMON_CONSTANT {
  public static get API_BASE_URL(): string {
    if (!environment.isProduction && environment.name === "LOCAL") {
      return 'https://api.carvia-test.org/vendor-service';
    } else {
      return window.location.origin;
    }
  }

  public static get DOMAIN_BASE_URL(): string{
      return environment.domainBaseUri
  }
}
